export default "__VITE_ASSET__CwiodU$B__"